"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _CrossCircle = _interopRequireDefault(require("../Icons/CrossCircle"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _breakpoints = _interopRequireDefault(require("../../constants/breakpoints"));

var _FileIcons = _interopRequireDefault(require("../FileIcons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\twidth: ", ";\n\tbackground: ", ";\n\tz-index: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tfloat: left;\n\tmargin-right: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tfloat: right;\n\tcolor: ", ";\n\tcursor: pointer;\n\tmargin-top: 2px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\twidth: 80% !important;\n\tfloat: left;\n\twidth: auto;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 40px;\n\tcolor: ", ";\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\n\t@media screen and (max-width: ", ") {\n\t\twidth: 70% !important;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\toverflow: hidden;\n\tposition: relative;\n\twidth: 100%;\n\tfloat: left;\n\tbackground: ", ";\n\tpadding: ", ";\n\tmargin-bottom: ", ";\n\tborder-radius: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var StyledSelectedFile = _styledComponents.default.div(_templateObject(), _colors.default.greyPale, _spacing.default.s2, _spacing.default.s1, _vars.default.borderRadius);

StyledSelectedFile.displayName = StyledSelectedFile;

var FileName = _styledComponents.default.div(_templateObject2(), function (_ref) {
  var hasError = _ref.hasError;
  return hasError ? _colors.default.error : _colors.default.textColor;
}, _breakpoints.default.smallDesktop);

FileName.displayName = 'FileName';
var RemoveFile = (0, _styledComponents.default)(_CrossCircle.default)(_templateObject3(), _colors.default.primary);
RemoveFile.displayName = 'RemoveFile';
var FileIconStyled = (0, _styledComponents.default)(_FileIcons.default)(_templateObject4(), _spacing.default.s2);
FileIconStyled.displayName = 'FileIconStyled';

var Progress = _styledComponents.default.div(_templateObject5(), function (props) {
  return props.progress;
}, _colors.default.primaryLighter);

Progress.displayName = 'Progress';

var Content = _styledComponents.default.div(_templateObject6());

Content.displayName = 'Content';

var SelectedFile = function SelectedFile(_ref2) {
  var fileName = _ref2.fileName,
      removeFile = _ref2.removeFile,
      progress = _ref2.progress,
      hasError = _ref2.hasError,
      rest = _objectWithoutPropertiesLoose(_ref2, ["fileName", "removeFile", "progress", "hasError"]);

  if (!fileName) {
    return null;
  }

  return _react.default.createElement(StyledSelectedFile, rest, progress && _react.default.createElement(Progress, {
    role: "progressbar",
    "aria-valuenow": parseInt(progress, 10),
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    progress: progress
  }), _react.default.createElement(Content, null, _react.default.createElement(FileIconStyled, {
    fileName: fileName
  }), _react.default.createElement(FileName, {
    hasError: hasError
  }, fileName), removeFile && !progress && _react.default.createElement(RemoveFile, {
    role: "button",
    "aria-label": "Remove file",
    size: 20,
    onClick: removeFile
  })));
};

SelectedFile.defaultProps = {
  progress: null,
  hasError: false,
  removeFile: undefined
};
SelectedFile.propTypes = {
  fileName: _propTypes.string.isRequired,
  progress: _propTypes.string,
  hasError: _propTypes.bool,
  removeFile: _propTypes.func
};
var _default = SelectedFile;
exports.default = _default;